import { getLabel } from "../labels";

export function getUkCombinationName(combId, isAccumulator) {
	let ukName = '';
	if (isAccumulator) {
			switch (combId) {
				case 1: { ukName = getLabel('uk_system_tuples.single_accumulator'); break; }
				case 2: { ukName = getLabel('uk_system_tuples.double_accumulator'); break; }
				case 3: { ukName = getLabel('uk_system_tuples.treble_accumulator'); break; }
				default: { ukName = getLabel('uk_system_tuples.generic_accumulator'); break; }
		}
	} else {
		switch (combId) {
			case 1: { ukName = getLabel('uk_system_tuples.singles'); break; }
			case 2: { ukName = getLabel('uk_system_tuples.doubles'); break; }
			case 3: { ukName = getLabel('uk_system_tuples.trebles'); break; }
			case 31: { ukName = getLabel('uk_system_tuples.trixie'); break; }
			case 32: { ukName = getLabel('uk_system_tuples.patent'); break; }
			case 33: { ukName = getLabel('uk_system_tuples.yankee11'); break; }
			case 34: { ukName = getLabel('uk_system_tuples.lucky15'); break; }
			case 35: { ukName = getLabel('uk_system_tuples.canadian'); break; }
			case 36: { ukName = getLabel('uk_system_tuples.lucky31'); break; }
			case 37: { ukName = getLabel('uk_system_tuples.heinz'); break; }
			case 38: { ukName = getLabel('uk_system_tuples.lucky63'); break; }
			case 39: { ukName = getLabel('uk_system_tuples.triple_yankee'); break; }
			case 40: { ukName = getLabel('uk_system_tuples.super_heinz'); break; }
			case 41: { ukName = getLabel('uk_system_tuples.goliath'); break; }
			default: { ukName = getLabel('uk_system_tuples.generic_fold').replaceAll('{{COMB-ID}}', combId); break; } 
		}
	}
	return ukName;
}
